// Product Feature Carousel - Fixed button click issues
class ProductFeatureCarousel {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.container = document.querySelector(`[data-section-id="${sectionId}"]`);
    
    if (!this.container) {
      console.error(`Section ${sectionId} not found`);
      return;
    }
    
    // Get elements
    this.carousel = this.container.querySelector('.pfc-mobile-carousel');
    this.track = this.container.querySelector('.pfc-carousel-track');
    this.items = this.container.querySelectorAll('.pfc-carousel-item');
    this.indicators = this.container.querySelectorAll('.pfc-indicator');
    this.prevBtn = this.container.querySelector('.pfc-prev');
    this.nextBtn = this.container.querySelector('.pfc-next');
    
    // Only initialize carousel on mobile
    this.isMobile = window.innerWidth <= 767;
    this.shouldInitialize = this.isMobile && this.carousel && this.items.length > 0;
    
    if (!this.shouldInitialize) {
      // Still need to handle desktop image hover effects
      this.setupImageHoverEffects();
      return;
    }
    
    // Initialize properties
    this.currentIndex = 0;
    this.totalItems = this.items.length;
    this.autoPlayInterval = null;
    
    console.log(`Product Feature Carousel ${sectionId} initialized with ${this.totalItems} items`);
    
    this.init();
  }
  
  init() {
    this.setupEventListeners();
    this.updateCarousel();
    
    // Get settings for autoplay
    const enableAutoplay = this.container.dataset.enableAutoplay !== 'false';
    if (enableAutoplay) {
      this.startAutoPlay();
    }
  }
  
  setupEventListeners() {
    // Indicators - 修复点击事件
    this.indicators.forEach(indicator => {
      indicator.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const index = parseInt(e.currentTarget.dataset.pfcIndex || e.target.dataset.pfcIndex);
        console.log(`Indicator clicked: ${index}`);
        this.goToSlide(index);
        this.resetAutoPlay();
      });
    });
    
    // Navigation buttons - 修复点击事件
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('Prev button clicked');
        this.prevSlide();
        this.resetAutoPlay();
      });
    }
    
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('Next button clicked');
        this.nextSlide();
        this.resetAutoPlay();
      });
    }
    
    // Touch swipe support
    this.setupSwipeSupport();
    
    // Pause on hover
    if (this.carousel) {
      this.carousel.addEventListener('mouseenter', () => this.pauseAutoPlay());
      this.carousel.addEventListener('mouseleave', () => this.resetAutoPlay());
    }
    
    // Handle resize
    window.addEventListener('resize', () => this.handleResize());
  }
  
  setupSwipeSupport() {
    if (!this.track) return;
    
    let touchStartX = 0;
    let touchEndX = 0;
    
    this.track.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      this.pauseAutoPlay();
    }, { passive: true });
    
    this.track.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe(touchStartX, touchEndX);
      this.resetAutoPlay();
    }, { passive: true });
  }
  
  handleSwipe(startX, endX) {
    const swipeThreshold = 50;
    const diff = startX - endX;
    
    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        // Swipe left - next slide
        this.nextSlide();
      } else {
        // Swipe right - previous slide
        this.prevSlide();
      }
    }
  }
  
  goToSlide(index) {
    if (index < 0 || index >= this.totalItems) return;
    
    this.currentIndex = index;
    this.updateCarousel();
  }
  
  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.totalItems;
    this.updateCarousel();
  }
  
  prevSlide() {
    this.currentIndex = (this.currentIndex - 1 + this.totalItems) % this.totalItems;
    this.updateCarousel();
  }
  
  updateCarousel() {
    // Update track position
    const offset = -(this.currentIndex * (100 / 3)); // 33.333%
    this.track.style.transform = `translateX(${offset}%)`;
    
    // Update indicators
    this.indicators.forEach((indicator, index) => {
      if (index === this.currentIndex) {
        indicator.classList.add('pfc-active');
      } else {
        indicator.classList.remove('pfc-active');
      }
    });
    
    console.log(`Slide updated to index: ${this.currentIndex}`);
  }
  
  startAutoPlay() {
    if (!this.isMobile || !this.container) return;
    
    this.pauseAutoPlay();
    
    // Get autoplay speed from settings or use default
    const enableAutoplay = this.container.dataset.enableAutoplay !== 'false';
    if (!enableAutoplay) return;
    
    const autoplaySpeed = parseInt(this.container.dataset.autoplaySpeed) || 3000;
    
    this.autoPlayInterval = setInterval(() => {
      this.nextSlide();
    }, autoplaySpeed);
  }
  
  pauseAutoPlay() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
    }
  }
  
  resetAutoPlay() {
    this.startAutoPlay();
  }
  
  handleResize() {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth <= 767;
    
    // Handle display switching between mobile and desktop
    if (wasMobile !== this.isMobile) {
      console.log(`Device changed to: ${this.isMobile ? 'mobile' : 'desktop'}`);
      
      if (this.isMobile && this.carousel) {
        // Show carousel on mobile
        this.carousel.style.display = 'block';
        const desktopLayout = this.container.querySelector('.pfc-desktop-layout');
        if (desktopLayout) desktopLayout.style.display = 'none';
        this.startAutoPlay();
      } else if (!this.isMobile && this.carousel) {
        // Show desktop layout
        this.carousel.style.display = 'none';
        const desktopLayout = this.container.querySelector('.pfc-desktop-layout');
        if (desktopLayout) desktopLayout.style.display = 'flex';
        this.pauseAutoPlay();
      }
    }
  }
  
  setupImageHoverEffects() {
    const featureImages = this.container.querySelectorAll('.pfc-image');
    featureImages.forEach(img => {
      img.addEventListener('mouseenter', function() {
        this.style.transform = 'scale(1.05)';
      });
      
      img.addEventListener('mouseleave', function() {
        this.style.transform = 'scale(1)';
      });
    });
  }
}

// Initialize all carousels on page load
document.addEventListener('DOMContentLoaded', function() {
  console.log('Initializing Product Feature Carousels...');
  
  // Store instances for access
  window.pfcInstances = {};
  
  const sections = document.querySelectorAll('[data-section-id]');
  
  sections.forEach(section => {
    const sectionId = section.dataset.sectionId;
    const hasFeatureCarousel = section.querySelector('.pfc-features');
    
    if (hasFeatureCarousel) {
      console.log(`Found Product Feature Carousel in section ${sectionId}`);
      
      // Get settings from section
      const enableAutoplayInput = section.querySelector('[name*="enable_autoplay"]');
      const autoplaySpeedInput = section.querySelector('[name*="autoplay_speed"]');
      
      const enableAutoplay = enableAutoplayInput ? 
        (enableAutoplayInput.value !== 'false') : true;
      
      const autoplaySpeed = autoplaySpeedInput ? 
        parseInt(autoplaySpeedInput.value) || 3000 : 3000;
      
      // Store settings as data attributes
      section.dataset.enableAutoplay = enableAutoplay;
      section.dataset.autoplaySpeed = autoplaySpeed;
      
      // Initialize carousel
      const instance = new ProductFeatureCarousel(sectionId);
      if (instance.shouldInitialize) {
        window.pfcInstances[sectionId] = instance;
      }
    }
  });
  
  console.log(`Product Feature Carousel: Initialized ${Object.keys(window.pfcInstances).length} carousel(s)`);
  
  // Also setup image hover effects for all sections (including desktop)
  const allImages = document.querySelectorAll('.pfc-image');
  allImages.forEach(img => {
    img.addEventListener('mouseenter', function() {
      this.style.transform = 'scale(1.05)';
    });
    
    img.addEventListener('mouseleave', function() {
      this.style.transform = 'scale(1)';
    });
  });
});

// Alternative simpler initialization for debugging
function initProductFeatureCarouselSimple() {
  const carousels = document.querySelectorAll('.pfc-mobile-carousel');
  
  carousels.forEach((carousel, index) => {
    if (window.innerWidth > 767) return;
    
    const track = carousel.querySelector('.pfc-carousel-track');
    const items = carousel.querySelectorAll('.pfc-carousel-item');
    const indicators = carousel.querySelectorAll('.pfc-indicator');
    const prevBtn = carousel.querySelector('.pfc-prev');
    const nextBtn = carousel.querySelector('.pfc-next');
    
    let currentIndex = 0;
    const totalItems = items.length;
    
    if (totalItems <= 1) return;
    
    function updateCarousel() {
      const offset = -(currentIndex * 33.333);
      if (track) track.style.transform = `translateX(${offset}%)`;
      
      indicators.forEach((indicator, idx) => {
        if (idx === currentIndex) {
          indicator.classList.add('pfc-active');
        } else {
          indicator.classList.remove('pfc-active');
        }
      });
    }
    
    // Indicators
    indicators.forEach((indicator, idx) => {
      indicator.addEventListener('click', () => {
        currentIndex = idx;
        updateCarousel();
      });
    });
    
    // Prev button
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        currentIndex = (currentIndex - 1 + totalItems) % totalItems;
        updateCarousel();
      });
    }
    
    // Next button
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        currentIndex = (currentIndex + 1) % totalItems;
        updateCarousel();
      });
    }
    
    // Auto play
    let autoPlayInterval = setInterval(() => {
      currentIndex = (currentIndex + 1) % totalItems;
      updateCarousel();
    }, 3000);
    
    // Pause on hover
    carousel.addEventListener('mouseenter', () => clearInterval(autoPlayInterval));
    carousel.addEventListener('mouseleave', () => {
      autoPlayInterval = setInterval(() => {
        currentIndex = (currentIndex + 1) % totalItems;
        updateCarousel();
      }, 3000);
    });
    
    updateCarousel();
  });
}

// Add this as a fallback initialization
document.addEventListener('DOMContentLoaded', function() {
  // Try the complex initialization first
  setTimeout(() => {
    // If no instances were created, try the simple one
    if (!window.pfcInstances || Object.keys(window.pfcInstances).length === 0) {
      console.log('Using simple initialization for Product Feature Carousel');
      initProductFeatureCarouselSimple();
    }
  }, 500);
});

// For Shopify theme editor
if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', (event) => {
    const sectionId = event.detail.sectionId;
    
    setTimeout(() => {
      const section = document.querySelector(`[data-section-id="${sectionId}"]`);
      if (section && section.querySelector('.pfc-features')) {
        console.log(`Shopify section loaded: ${sectionId}`);
        
        // Remove old instance if exists
        if (window.pfcInstances && window.pfcInstances[sectionId]) {
          delete window.pfcInstances[sectionId];
        }
        
        // Re-initialize
        const instance = new ProductFeatureCarousel(sectionId);
        if (instance.shouldInitialize) {
          window.pfcInstances[sectionId] = instance;
        }
      }
    }, 100);
  });
}